export default [
    {
        path: 'relatorio-estorno-entrada',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-estorno-entrada' */
            '@/views/almoxarifado/relatorio-estorno-entrada/Index'
        ),
        redirect: 'relatorio-estorno-entrada/index',
        children: [
            {
                name: 'almoxarifado-relatorio-estorno-entrada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-estorno-entrada' */
                    '@/views/almoxarifado/relatorio-estorno-entrada/List.vue'
                ),
            },
        ],
    },
]